// extracted by mini-css-extract-plugin
module.exports = {"AddEditNote":"AddEditNote_AddEditNote__2vEEV"};